import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../redux/hooks'
import { selectAuthenticatedUser } from '../redux/slices/auth.slice'

interface AdminGuardProps {
  redirectPath?: string
}

function AdminGuard({ redirectPath = '/' }: AdminGuardProps): JSX.Element {
  const { access_token, role } = useAppSelector(selectAuthenticatedUser)
  
  if (!access_token || role !== 'admin') {
    return <Navigate to={redirectPath} replace />
  }
  
  return <Outlet />
}

export default AdminGuard
